import { render, staticRenderFns } from "./LocationPaySettings.vue?vue&type=template&id=2f99f521&"
import script from "./LocationPaySettings.vue?vue&type=script&lang=js&"
export * from "./LocationPaySettings.vue?vue&type=script&lang=js&"
import style0 from "./LocationPaySettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports